var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isActive)?_c('div',{staticClass:"border border-primary",attrs:{"id":"git-info"}},[_c('span',[_vm._v(_vm._s(_vm.branch)+" : "),_c('i',[_vm._v("("+_vm._s(_vm.commit)+")")]),_vm._v(" "),_c('b',[_vm._v("by")]),_vm._v(" "),_c('i',[_vm._v(_vm._s(_vm.author))]),_vm._v(" "),_c('b',[_vm._v("on")]),_vm._v(" "),_c('i',[_vm._v(_vm._s(_vm.date))])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b54419a6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/common/GitInfo.vue
// module id = 395
// module chunks = 1